// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".label-field[data-v-216d690d]{color:#00475a;font:normal normal 700 16px/19px Calibri}.btn[data-v-216d690d]{display:flex;justify-content:space-around;padding-bottom:5px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
